import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { LayoutService } from '../../service/layout.service';
@UntilDestroy()
@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit, OnChanges {
  constructor(private layout: LayoutService, public appService: AppService, private router: Router) {}

  /**sit时候的尺寸 [宽,高] */
  @Input() sitSize: string[] = [];
  /**sit h5 时候的尺寸 [宽,高] */
  @Input() sitSizeH5: string[] = [];
  /**线上时候的尺寸 [宽,高] */
  @Input() onlineSize: string[] = [];
  /**线上 h5 时候的尺寸 [宽,高] */
  @Input() onlineSizeH5: string[] = [];
  /**固定是h5或者pc的尺寸 */
  @Input() lockDevice?: 'h5' | 'web';
  /**固定日夜主题 */
  @Input() lockTheme?: 'sun' | 'moon';
  /**是否可点击（返回首页） */
  @Input() clickable: boolean = false;
  /** 自定义Logo */
  @Input() logoSrc: string = '';

  isOnline: boolean = environment.isOnline;
  isH5!: boolean;
  theme!: 'sun' | 'moon';
  logoUrl!: string | null;

  get size() {
    return this.isOnline
      ? this.lockDevice
        ? this.lockDevice === 'h5'
          ? this.onlineSizeH5
          : this.onlineSize
        : this.isH5
        ? this.onlineSizeH5
        : this.onlineSize
      : this.lockDevice
      ? this.lockDevice === 'h5'
        ? this.sitSizeH5
        : this.sitSize
      : this.isH5
      ? this.sitSizeH5
      : this.sitSize;
  }

  get width() {
    const num = this.size[0] ?? 'auto';
    if (num === 'auto') return num;
    return Number(num).divide(this.layout.remRate) + 'rem';
  }

  get height() {
    const num = this.size[1] ?? 'auto';
    if (num === 'auto') return num;
    return Number(num).divide(this.layout.remRate) + 'rem';
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { lockDevice, lockTheme } = changes;
    if (lockDevice) {
      const { previousValue, currentValue } = lockDevice;
      if (currentValue !== previousValue) {
        this.setLogo();
      }
    }

    if (lockTheme) {
      const { previousValue, currentValue } = lockTheme;
      if (currentValue !== previousValue) {
        this.setLogo();
      }
    }
  }

  ngOnInit() {
    combineLatest([this.layout.isH5$, this.appService.themeSwitch$])
      .pipe(untilDestroyed(this))
      .subscribe(([isH5, theme]) => {
        this.isH5 = isH5;
        this.theme = theme;
        if (!this.logoSrc) {
          this.setLogo();
        } else {
          this.logoUrl = this.logoSrc;
        }
      });
  }

  /** 设定Logo */
  setLogo() {
    const device = this.lockDevice ?? (this.isH5 ? 'h5' : 'web');
    const theme = this.lockTheme ?? this.theme;
    const key = `${device}Logo${theme?.charAt(0).toUpperCase() + theme?.slice(1)}`;
    this.logoUrl = `${environment.resourceUrl}/${this.appService.tenantConfig[key] || ''}`;
  }

  click() {
    if (!this.clickable) return;
    this.router.navigate(['/', this.appService.languageCode]);
  }
}
